import React, { useState, useEffect, useMemo } from 'react';
import { withStyles, Dialog, Tooltip, IconButton, DialogActions, DialogContent, DialogContentText, Button, DialogTitle } from '@material-ui/core';
import { hasPermission, localization, isValidJson, formatDate } from '../../sc-utilities';
import { LinkOff, CloudDownload } from '@material-ui/icons';
import MaterialTable from 'material-table';
import Toolbar from '../../sc-utilities/Toolbar';
import { snackActions } from '../../sc-utilities/SnackBar';
import config from "../../../config/config";
import { download } from "../../sc-utilities/download.utils";

const styles = theme => ({
    "@global": {
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: 'none',
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
    },
    paletteButtons: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        margin: theme.spacing(),
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const ExternalSystemSettingTable = props => {
    const { setExternal, external, product, activeCustomer, classes, saveColumnsFilter, translations, permissions, columns } = props;
    let visible = columns && columns['ExternalSystem'];
    const [eraseOnlyDevice, setEraseOnlyDevice] = useState({ open: false, value: null })
    const tableRef = React.createRef();
    const [unpairExternal, setUnpairExternal] = useState({ open: false, externalID: null, forBulk: null })

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 200, maxWidth: 200 },
            filtering: false,
            render: rowData => {
                return (<>
                    <Tooltip title={translations["unpair_product"] || "Unpair product"}>
                        <IconButton value={rowData.ProductExternalInfoID} aria-label={translations["unpair_product"] || "Unpair product"} onClick={handleUnpairProductDialog}>
                            <LinkOff />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={translations["download_support_log"] || "Download support log"}>
                        <IconButton value={rowData.ProductExternalInfoID} aria-label={translations["unpair_product"] || "Download support log"} onClick={handleDownloadSupportLogDialog}>
                            <CloudDownload />
                        </IconButton>
                    </Tooltip>
                </>
                )
            }
        },
        {
            field: 'ExternalID',
            title: translations["external_id"] || 'External ID',
            hidden: visible ? visible['ExternalID'] : false,
            render: rowData => {
                return rowData.ExternalID ? rowData.ExternalID : '-';

            },
        },
        {
            title: translations["service_type"] || "Service type", field: 'ServiceType',
            hidden: visible ? visible['ServiceType'] : false,
            render: rowData => {
                return rowData.ExternalServiceType ? rowData.ExternalServiceType : '-';
            },
        },
        {
            title: translations["data_sent"] || "Data sent", field: 'SendArticleData',
            hidden: visible ? visible['SendArticleData'] : false,
            render: rowData => {
                return rowData.DataExport === true ? translations['extenral_data_ready_to_send'] || 'Ready to send' : rowData.DataExport === false ? translations['external_data_already_sent'] || 'Already sent' : translations['external_data_error_sending'] || 'Error while sending';
            },
        },
        {
            title: translations["last_response"] || "Last Response", field: 'LastResponse',
            hidden: visible ? visible['LastResponse'] : false,
            render: rowData => {
                if (rowData.LastResponse && isValidJson(rowData.LastResponse)) {
                    let lastResponse = JSON.parse(rowData.LastResponse);
                    return `${lastResponse.Status ?? (translations["short_not_assigned"] || 'n/a')} - ${lastResponse.Datetime ? formatDate(lastResponse.Datetime) : (translations["short_not_assigned"] || 'n/a')}`
                }
                return translations["short_not_assigned"] || 'n/a'
            },
        }
    ];

    if (!hasPermission(permissions, 'unpair_product')) {
        tableColumns.splice(0, 1);
    }
    const handleClose = () => {
        setEraseOnlyDevice({ ...eraseOnlyDevice, open: false, })
    };

    const handleCloseYes = () => {
        setEraseOnlyDevice({ ...eraseOnlyDevice, open: false, value: !eraseOnlyDevice.value })
    };


    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: false,
            sorting: false,
            selection: true,
            search: false,
            minBodyHeight: window.innerHeight - 380 < 250 ? 250 : window.innerHeight - 380,
            maxBodyHeight: window.innerHeight - 380,
            pageSizeOptions: rowsPageSizeInit,
            exportButton: false,
            columnsButton: true,
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    useEffect(() => {
        const filterQuery = () => {
            tableRef.current && tableRef.current.onQueryChange()

        }
        filterQuery()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product]);

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }
    async function fetchTableData(query) {
        let data = product && product.ProductExternalInfo && product.ProductExternalInfo instanceof Array ? product.ProductExternalInfo : []
        let q = filterQuery(query.filters);
        query['ActiveCustomerID'] = activeCustomer;
        query['q'] = q;
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'] });


        let rowsPearPage = [20, 50, 100]
        if (data.length < 20) {
            rowsPearPage.push(data.length)
        }
        setTableOptions({ ...tableOptions, pageSize: data.length < 20 ? data.length : data.length < 50 ? 20 : 50, pageSizeOptions: rowsPearPage });
        return { data: data, page: query.page, pageSize: pageSize, totalCount: data.length };
    }

    const tableTitle = () => {
        return <div>
            {translations['external_information'] || 'Product External Information'}
        </div>
    }

    const handleUnpairProduct = async () => {
        tableRef.current && tableRef.current.onQueryChange()

        let result = await props.onUnpairExternalPC({ data: unpairExternal?.externalID, ActiveCustomerID: activeCustomer });

        setUnpairExternal({ ...unpairExternal, open: false, externalID: null, forBulk: null })
        setExternal(!external)
        if (result) {
            return snackActions.snackBarComponent(`${translations["product_unpaired_success"] || 'Product is successfully unpaired'}.`, 'success');
        }
        return snackActions.snackBarComponent(`${translations["product_unpaired_success"] || 'Failed to unpair product'}`, 'error');
    }

    const handleDownloadSupportLog = async ProductExternalInfoID => {
        const objectURL = `${config.backend_domain}:${config.backend_port}/external-system-setting/download-support-log?ProductExternalInfoID=${ProductExternalInfoID}&ActiveCustomerID=${activeCustomer}`;
        let exportDataSuccessful = await download(objectURL);
        tableRef.current && tableRef.current.onQueryChange();
        if (!exportDataSuccessful) {
            return snackActions.snackBarComponent(translations['download_error_msg'] || `Could not download file `, 'error');
        }
    };


    const tableActions = [
        {
            tooltip: translations["remove_all_selected"] || "Remove All Selected  order",
            icon: <LinkOff />,
            onClick: (rowData) => handleBulkUnpairProductDialog(rowData.map(id => id.ProductExternalInfoID))
        },
    ]

    const handleBulkUnpairProduct = async () => {
        tableRef.current && tableRef.current.onQueryChange()
        let result = await props.onUnpairBulkExternalPC({ data: unpairExternal.forBulk, ActiveCustomerID: activeCustomer });
        setUnpairExternal({ ...unpairExternal, open: false })
        setExternal(!external)
        if (result) {
            return snackActions.snackBarComponent(`${translations["product_unpaired_success"] || 'Product is successfully unpaired'}.`, 'success');
        }
        return snackActions.snackBarComponent(`${translations["product_unpaired_success"] || 'Failed to unpair product'}`, 'error');
    }
    const handleUnpairProductDialog = (event) => {
        let externalID = event.currentTarget.value;
        setUnpairExternal({ ...unpairExternal, open: true, externalID: externalID, forBulk: null })
    }
    const handleDownloadSupportLogDialog = async (event) => {
        await handleDownloadSupportLog(event.currentTarget.value);
    }


    const handleBulkUnpairProductDialog = (IDs) => {
        setUnpairExternal({ ...unpairExternal, open: true, externalID: null, forBulk: IDs })
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`UserActivity`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState
    }




    return (
        <div className={classes.root}>
            <MaterialTable
                tableRef={tableRef}
                components={{
                    Toolbar: props => (
                        <Toolbar
                            data={props}
                            actions={tableActions}
                            selectedRows={props.selectedRows}
                            translations={translations}
                        />
                    )
                }}
                title={tableTitle()}
                columns={columnObject}
                data={fetchTableData}
                options={tableOptions}
                onChangeRowsPerPage={(size) => {
                    pageSize = size
                }}
                localization={localization(translations)}
                onChangeColumnHidden={columnHidden}
                onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
            />
            <Dialog
                open={eraseOnlyDevice.open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                disableBackdropClick={true}
                disableEscapeKeyDown={false}
                fullWidth={true}
            >
                <DialogTitle id="form-dialog-title"> {translations['set_as_dedicated_erase_machine'] || 'Set as dedicated erase machine'}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {translations['carefully_when_doing'] || 'Be carefully when doing this'}.<br />
                        {translations['you_sure_unpair'] || 'Are you sure you want to unpair'} {unpairExternal.forBulk ? translations['those_products'] || 'these products' : translations['this_products'] || 'this product'} ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="contained" className={classes.buttonSafe}>
                        {translations['cancel'] || 'Cancel'}

                    </Button>
                    <Button onClick={handleCloseYes} variant="contained" className={classes.buttonDanger}>
                        {translations['confirm'] || 'Confirm'}


                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={unpairExternal.open}
                onClose={() => setUnpairExternal({ ...unpairExternal, open: false, externalID: null, forBulk: null })}
                aria-labelledby="form-dialog-title"
                disableBackdropClick={true}
                disableEscapeKeyDown={false}
                fullWidth={true}
            >
                <DialogTitle
                    id="form-dialog-title">{unpairExternal.forBulk ? 'Bulk unpair product' : ' Unpair product'}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {translations['carefully_when_doing'] || 'Be carefully when doing this'}.<br />
                        {translations['you_sure_unpair'] || 'Are you sure you want to unpair'} {unpairExternal.forBulk ? translations['those_products'] || 'these products' : translations['this_products'] || 'this product'} ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className={classes.buttonSafe} onClick={() => setUnpairExternal({
                        ...unpairExternal,
                        open: false,
                        externalID: null,
                        forBulk: null
                    })} variant="contained">
                        {translations['no'] || 'No'}
                    </Button>
                    <Button className={classes.buttonDanger}
                        onClick={unpairExternal.forBulk ? handleBulkUnpairProduct : handleUnpairProduct}
                        variant="contained">
                        {translations['yes'] || 'Yes'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    );

}

export default (withStyles(styles, { withTheme: true })(ExternalSystemSettingTable));


